module.exports = __webpack_public_path__ + "img/1.40b17b7a.jpg";